import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import AboutPage from './AboutPage.jsx';

const rootElement = typeof document !== 'undefined' ? document.getElementById('root') : null;

if (rootElement) {
  if (rootElement.hasChildNodes()) {
    hydrateRoot(
      rootElement,
      <StrictMode>
        <AboutPage />
      </StrictMode>
    );
  } else {
    createRoot(rootElement).render(
      <StrictMode>
        <AboutPage />
      </StrictMode>
    );
  }
}

export default AboutPage;
